module.exports = __webpack_public_path__ + "media/images/icons/filled/camera-c2fdcaa03e99e55152c5d31ed71dc448.svg";